var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[(_vm.loading)?_c('div',{staticClass:"loader-wrapper"},[_c('pulse-loader')],1):_vm._e(),_c('ItemList',{attrs:{"itemIds":_vm.itemIds}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }